import type { ReactNode } from "react"

/** Heading + body block inside the shared Yardi Config SectionCard. */
export function ConfigSubsection({
    title,
    testId,
    headerActions,
    children,
}: {
    title: string
    testId?: string
    headerActions?: ReactNode
    children: ReactNode
}) {
    return (
        <div
            data-testid={testId}
            className="space-y-4 border-t border-slate-100 pt-5 first:border-t-0 first:pt-0"
        >
            <div className="flex flex-wrap items-center justify-between gap-3">
                <h3 className="m-0 text-[15px] font-semibold tracking-tight text-slate-800">{title}</h3>
                {headerActions != null ? (
                    <div className="flex flex-wrap items-center justify-end gap-2">{headerActions}</div>
                ) : null}
            </div>
            {children}
        </div>
    )
}
